/**
 * @generated SignedSource<<0ce3c6393f1f3607534b7928d7da7512>>
 * @relayHash 7c992ec15d581cbc0afcf255c8b8cd4f
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 01a7d78cb536c8d4d21def834c215f5bfbe84d0eb07a5c6355872d5d30164ab8

import type { ConcreteRequest } from 'relay-runtime';
export type ConvoAiErrorMessageTemplate = "A2A_ERROR" | "ACCEPTABLE_USE_VIOLATIONS" | "ERROR" | "PRE_EXECUTION_ERROR" | "%future added value";
export type ConvoAiMessageAuthorRole = "AGENT" | "ASSISTANT" | "HUMAN" | "%future added value";
export type useCommentAgentSessionStatusSubscription$variables = {
  cloudId: string;
  conversationId: string;
};
export type useCommentAgentSessionStatusSubscription$data = {
  readonly convoai_onAgentSessionUpdate: {
    readonly __typename: "ConvoAiConversationMessage";
    readonly actions: ReadonlyArray<{
      readonly key: string;
    } | null> | null;
    readonly agentSessionState: string | null;
    readonly role: ConvoAiMessageAuthorRole;
  } | {
    readonly __typename: "ConvoAiErrorMessage";
    readonly errorMessageTemplate: ConvoAiErrorMessageTemplate;
    readonly statusCode: number;
  } | {
    readonly __typename: "ConvoAiTraceMessage";
    readonly messageTemplate: string;
  } | {
    // This will never be '%other', but we need some
    // value in case none of the concrete values match.
    readonly __typename: "%other";
  } | null;
};
export type useCommentAgentSessionStatusSubscription = {
  response: useCommentAgentSessionStatusSubscription$data;
  variables: useCommentAgentSessionStatusSubscription$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "cloudId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "conversationId"
  }
],
v1 = [
  {
    "args": [
      {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
      },
      {
        "kind": "Variable",
        "name": "conversationId",
        "variableName": "conversationId"
      }
    ],
    "kind": "LinkedField",
    "name": "convoai_onAgentSessionUpdate",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "name": "__typename"
      },
      {
        "kind": "InlineFragment",
        "selections": [
          {
            "kind": "ScalarField",
            "name": "messageTemplate"
          }
        ],
        "type": "ConvoAiTraceMessage"
      },
      {
        "kind": "InlineFragment",
        "selections": [
          {
            "kind": "ScalarField",
            "name": "role"
          },
          {
            "kind": "ScalarField",
            "name": "agentSessionState"
          },
          {
            "concreteType": "ConvoAiAgentAction",
            "kind": "LinkedField",
            "name": "actions",
            "plural": true,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "key"
              }
            ]
          }
        ],
        "type": "ConvoAiConversationMessage"
      },
      {
        "kind": "InlineFragment",
        "selections": [
          {
            "alias": "errorMessageTemplate",
            "kind": "ScalarField",
            "name": "messageTemplate"
          },
          {
            "kind": "ScalarField",
            "name": "statusCode"
          }
        ],
        "type": "ConvoAiErrorMessage"
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "useCommentAgentSessionStatusSubscription",
    "selections": (v1/*: any*/),
    "type": "Subscription"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useCommentAgentSessionStatusSubscription",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "7c992ec15d581cbc0afcf255c8b8cd4f",
    "id": "01a7d78cb536c8d4d21def834c215f5bfbe84d0eb07a5c6355872d5d30164ab8",
    "metadata": {},
    "name": "useCommentAgentSessionStatusSubscription",
    "operationKind": "subscription",
    "text": "subscription useCommentAgentSessionStatusSubscription($cloudId:ID!,$conversationId:ID!){convoai_onAgentSessionUpdate(cloudId:$cloudId,conversationId:$conversationId)@optIn(to:\"ConvoAiAgentSessionUpdate\"){__typename,...on ConvoAiTraceMessage{messageTemplate},...on ConvoAiConversationMessage{role,agentSessionState,actions{key}},...on ConvoAiErrorMessage{errorMessageTemplate:messageTemplate,statusCode}}}"
  }
};
})();

(node as any).hash = "9ff053c5795e9c184fed44bf12bac377";

export default node;
